module.exports = __webpack_public_path__ + "static/media/exclamacao.4dc6d3d8.svg";